import React, { Component } from 'react';

class LoadingButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const defaultState = !this.props.isLoading && !this.props.isCompleted && !this.props.isError;

        return (
            <button style={this.props.style && this.props.style} className={`loadingButton ${this.props.isError ? "error" : ""} ${this.props.isCompleted ? "completed" : ""} ${!defaultState ? "clicked" : ""}`}
                onClick={defaultState ? this.props.onClick : undefined}>
                <div className={`submit ${defaultState ? "active" : ""}`}>
                    <div>{this.props.submitText}</div></div>
                <div className={`loading ${this.props.isLoading ? "active" : ""}`}>
                    <i></i><div></div><div></div>
                </div>
                <div className={`completed ${this.props.isCompleted ? "active" : ""} ${!this.props.successText ? "onlyicon" : ""} `}>
                    <i></i><div>{this.props.successText}</div><div></div>
                </div>
                <div className={`error ${this.props.isError ? "active" : ""}  ${!this.props.errorText ? "onlyicon" : ""} `}>
                    <i></i><div>{this.props.errorText}</div><div></div>
                </div>
            </button>
        )
    }
}

export default LoadingButton;